import { render, staticRenderFns } from "./Koutu_Step.vue?vue&type=template&id=ffa0486e&scoped=true"
import script from "./Koutu_Step.vue?vue&type=script&lang=js"
export * from "./Koutu_Step.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Step.vue?vue&type=style&index=0&id=ffa0486e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa0486e",
  null
  
)

export default component.exports